export const municipalities = [  {label: "Akaa", value: "020"},
  {label: "Alajärvi", value: "005"},
  {label: "Alavieska", value: "009"},
  {label: "Alavus", value: "010"},
  {label: "Asikkala", value: "016"},
  {label: "Askola", value: "018"},
  {label: "Aura", value: "019"},
  {label: "Brändö", value: "035"},
  {label: "Eckerö", value: "043"},
  {label: "Enonkoski", value: "046"},
  {label: "Enontekiö", value: "047"},
  {label: "Espoo", value: "049"},
  {label: "Eura", value: "050"},
  {label: "Eurajoki", value: "051"},
  {label: "Evijärvi", value: "052"},
  {label: "Finström", value: "060"},
  {label: "Forssa", value: "061"},
  {label: "Föglö", value: "062"},
  {label: "Geta", value: "065"},
  {label: "Haapajärvi", value: "069"},
  {label: "Haapavesi", value: "071"},
  {label: "Hailuoto", value: "072"},
  {label: "Halsua", value: "074"},
  {label: "Hamina", value: "075"},
  {label: "Hammarland", value: "076"},
  {label: "Hankasalmi", value: "077"},
  {label: "Hanko", value: "078"},
  {label: "Harjavalta", value: "079"},
  {label: "Hartola", value: "081"},
  {label: "Hattula", value: "082"},
  {label: "Hausjärvi", value: "086"},
  {label: "Heinola", value: "111"},
  {label: "Heinävesi", value: "090"},
  {label: "Helsinki", value: "091"},
  {label: "Hirvensalmi", value: "097"},
  {label: "Hollola", value: "098"},
  {label: "Huittinen", value: "102"},
  {label: "Humppila", value: "103"},
  {label: "Hyrynsalmi", value: "105"},
  {label: "Hyvinkää", value: "106"},
  {label: "Hämeenkyrö", value: "108"},
  {label: "Hämeenlinna", value: "109"},
  {label: "Ii", value: "139"},
  {label: "Iisalmi", value: "140"},
  {label: "Iitti", value: "142"},
  {label: "Ikaalinen", value: "143"},
  {label: "Ilmajoki", value: "145"},
  {label: "Ilomantsi", value: "146"},
  {label: "Imatra", value: "153"},
  {label: "Inari", value: "148"},
  {label: "Inkoo", value: "149"},
  {label: "Isojoki", value: "151"},
  {label: "Isokyrö", value: "152"},
  {label: "Janakkala", value: "165"},
  {label: "Joensuu", value: "167"},
  {label: "Jokioinen", value: "169"},
  {label: "Jomala", value: "170"},
  {label: "Joroinen", value: "171"},
  {label: "Joutsa", value: "172"},
  {label: "Juuka", value: "176"},
  {label: "Juupajoki", value: "177"},
  {label: "Juva", value: "178"},
  {label: "Jyväskylä", value: "179"},
  {label: "Jämijärvi", value: "181"},
  {label: "Jämsä", value: "182"},
  {label: "Järvenpää", value: "186"},
  {label: "Kaarina", value: "202"},
  {label: "Kaavi", value: "204"},
  {label: "Kajaani", value: "205"},
  {label: "Kalajoki", value: "208"},
  {label: "Kangasala", value: "211"},
  {label: "Kangasniemi", value: "213"},
  {label: "Kankaanpää", value: "214"},
  {label: "Kannonkoski", value: "216"},
  {label: "Kannus", value: "217"},
  {label: "Karijoki", value: "218"},
  {label: "Karkkila", value: "224"},
  {label: "Karstula", value: "226"},
  {label: "Karvia", value: "230"},
  {label: "Kaskinen", value: "231"},
  {label: "Kauhajoki", value: "232"},
  {label: "Kauhava", value: "233"},
  {label: "Kauniainen", value: "235"},
  {label: "Kaustinen", value: "236"},
  {label: "Keitele", value: "239"},
  {label: "Kemi", value: "240"},
  {label: "Kemijärvi", value: "320"},
  {label: "Keminmaa", value: "241"},
  {label: "Kemiönsaari", value: "322"},
  {label: "Kempele", value: "244"},
  {label: "Kerava", value: "245"},
  {label: "Keuruu", value: "249"},
  {label: "Kihniö", value: "250"},
  {label: "Kinnula", value: "256"},
  {label: "Kirkkonummi", value: "257"},
  {label: "Kitee", value: "260"},
  {label: "Kittilä", value: "261"},
  {label: "Kiuruvesi", value: "263"},
  {label: "Kivijärvi", value: "265"},
  {label: "Kokemäki", value: "271"},
  {label: "Kokkola", value: "272"},
  {label: "Kolari", value: "273"},
  {label: "Konnevesi", value: "275"},
  {label: "Kontiolahti", value: "276"},
  {label: "Korsnäs", value: "280"},
  {label: "Koski", value: "284"},
  {label: "Kotka", value: "285"},
  {label: "Kouvola", value: "286"},
  {label: "Kristiinankaupunki", value: "287"},
  {label: "Kruunupyy", value: "288"},
  {label: "Kuhmo", value: "290"},
  {label: "Kuhmoinen", value: "291"},
  {label: "Kumlinge", value: "295"},
  {label: "Kuopio", value: "297"},
  {label: "Kuortane", value: "300"},
  {label: "Kurikka", value: "301"},
  {label: "Kustavi", value: "304"},
  {label: "Kuusamo", value: "305"},
  {label: "Kyyjärvi", value: "312"},
  {label: "Kärkölä", value: "316"},
  {label: "Kärsämäki", value: "317"},
  {label: "Kökar", value: "318"},
  {label: "Lahti", value: "398"},
  {label: "Laihia", value: "399"},
  {label: "Laitila", value: "400"},
  {label: "Lapinjärvi", value: "407"},
  {label: "Lapinlahti", value: "402"},
  {label: "Lappajärvi", value: "403"},
  {label: "Lappeenranta", value: "405"},
  {label: "Lapua", value: "408"},
  {label: "Laukaa", value: "410"},
  {label: "Lemi", value: "416"},
  {label: "Lemland", value: "417"},
  {label: "Lempäälä", value: "418"},
  {label: "Leppävirta", value: "420"},
  {label: "Lestijärvi", value: "421"},
  {label: "Lieksa", value: "422"},
  {label: "Lieto", value: "423"},
  {label: "Liminka", value: "425"},
  {label: "Liperi", value: "426"},
  {label: "Lohja", value: "444"},
  {label: "Loimaa", value: "430"},
  {label: "Loppi", value: "433"},
  {label: "Loviisa", value: "434"},
  {label: "Luhanka", value: "435"},
  {label: "Lumijoki", value: "436"},
  {label: "Lumparland", value: "438"},
  {label: "Luoto", value: "440"},
  {label: "Luumäki", value: "441"},
  {label: "Maalahti", value: "475"},
  {label: "Maarianhamina", value: "478"},
  {label: "Marttila", value: "480"},
  {label: "Masku", value: "481"},
  {label: "Merijärvi", value: "483"},
  {label: "Merikarvia", value: "484"},
  {label: "Miehikkälä", value: "489"},
  {label: "Mikkeli", value: "491"},
  {label: "Muhos", value: "494"},
  {label: "Multia", value: "495"},
  {label: "Muonio", value: "498"},
  {label: "Mustasaari", value: "499"},
  {label: "Muurame", value: "500"},
  {label: "Mynämäki", value: "503"},
  {label: "Myrskylä", value: "504"},
  {label: "Mäntsälä", value: "505"},
  {label: "Mänttä-Vilppula", value: "508"},
  {label: "Mäntyharju", value: "507"},
  {label: "Naantali", value: "529"},
  {label: "Nakkila", value: "531"},
  {label: "Nivala", value: "535"},
  {label: "Nokia", value: "536"},
  {label: "Nousiainen", value: "538"},
  {label: "Nurmes", value: "541"},
  {label: "Nurmijärvi", value: "543"},
  {label: "Närpiö", value: "545"},
  {label: "Orimattila", value: "560"},
  {label: "Oripää", value: "561"},
  {label: "Orivesi", value: "562"},
  {label: "Oulainen", value: "563"},
  {label: "Oulu", value: "564"},
  {label: "Outokumpu", value: "309"},
  {label: "Padasjoki", value: "576"},
  {label: "Paimio", value: "577"},
  {label: "Paltamo", value: "578"},
  {label: "Parainen", value: "445"},
  {label: "Parikkala", value: "580"},
  {label: "Parkano", value: "581"},
  {label: "Pedersören", value: "599"},
  {label: "Pelkosenniemi", value: "583"},
  {label: "Pello", value: "854"},
  {label: "Perho", value: "584"},
  {label: "Pertunmaa", value: "588"},
  {label: "Petäjävesi", value: "592"},
  {label: "Pieksämäki", value: "593"},
  {label: "Pielavesi", value: "595"},
  {label: "Pietarsaari", value: "598"},
  {label: "Pihtipudas", value: "601"},
  {label: "Pirkkala", value: "604"},
  {label: "Polvijärvi", value: "607"},
  {label: "Pomarkku", value: "608"},
  {label: "Pori", value: "609"},
  {label: "Pornainen", value: "611"},
  {label: "Porvoo", value: "638"},
  {label: "Posio", value: "614"},
  {label: "Pudasjärvi", value: "615"},
  {label: "Pukkila", value: "616"},
  {label: "Punkalaidun", value: "619"},
  {label: "Puolanka", value: "620"},
  {label: "Puumala", value: "623"},
  {label: "Pyhtää", value: "624"},
  {label: "Pyhäjoki", value: "625"},
  {label: "Pyhäjärvi", value: "626"},
  {label: "Pyhäntä", value: "630"},
  {label: "Pyhäranta", value: "631"},
  {label: "Pälkäne", value: "635"},
  {label: "Pöytyä", value: "636"},
  {label: "Raahe", value: "678"},
  {label: "Raasepori", value: "710"},
  {label: "Raisio", value: "680"},
  {label: "Rantasalmi", value: "681"},
  {label: "Ranua", value: "683"},
  {label: "Rauma", value: "684"},
  {label: "Rautalampi", value: "686"},
  {label: "Rautavaara", value: "687"},
  {label: "Rautjärvi", value: "689"},
  {label: "Reisjärvi", value: "691"},
  {label: "Riihimäki", value: "694"},
  {label: "Ristijärvi", value: "697"},
  {label: "Rovaniemi", value: "698"},
  {label: "Ruokolahti", value: "700"},
  {label: "Ruovesi", value: "702"},
  {label: "Rusko", value: "704"},
  {label: "Rääkkylä", value: "707"},
  {label: "Saarijärvi", value: "729"},
  {label: "Salla", value: "732"},
  {label: "Salo", value: "734"},
  {label: "Saltvik", value: "736"},
  {label: "Sastamala", value: "790"},
  {label: "Sauvo", value: "738"},
  {label: "Savitaipale", value: "739"},
  {label: "Savonlinna", value: "740"},
  {label: "Savukoski", value: "742"},
  {label: "Seinäjoki", value: "743"},
  {label: "Sievi", value: "746"},
  {label: "Siikainen", value: "747"},
  {label: "Siikajoki", value: "748"},
  {label: "Siikalatva", value: "791"},
  {label: "Siilinjärvi", value: "749"},
  {label: "Simo", value: "751"},
  {label: "Sipoo", value: "753"},
  {label: "Siuntio", value: "755"},
  {label: "Sodankylä", value: "758"},
  {label: "Soini", value: "759"},
  {label: "Somero", value: "761"},
  {label: "Sonkajärvi", value: "762"},
  {label: "Sotkamo", value: "765"},
  {label: "Sottunga", value: "766"},
  {label: "Sulkava", value: "768"},
  {label: "Sund", value: "771"},
  {label: "Suomussalmi", value: "777"},
  {label: "Suonenjoki", value: "778"},
  {label: "Sysmä", value: "781"},
  {label: "Säkylä", value: "783"},
  {label: "Taipalsaari", value: "831"},
  {label: "Taivalkoski", value: "832"},
  {label: "Taivassalo", value: "833"},
  {label: "Tammela", value: "834"},
  {label: "Tampere", value: "837"},
  {label: "Tervo", value: "844"},
  {label: "Tervola", value: "845"},
  {label: "Teuva", value: "846"},
  {label: "Tohmajärvi", value: "848"},
  {label: "Toholampi", value: "849"},
  {label: "Toivakka", value: "850"},
  {label: "Tornio", value: "851"},
  {label: "Turku", value: "853"},
  {label: "Tuusniemi", value: "857"},
  {label: "Tuusula", value: "858"},
  {label: "Tyrnävä", value: "859"},
  {label: "Ulvila", value: "886"},
  {label: "Urjala", value: "887"},
  {label: "Utajärvi", value: "889"},
  {label: "Utsjoki", value: "890"},
  {label: "Uurainen", value: "892"},
  {label: "Uusikaarlepyy", value: "893"},
  {label: "Uusikaupunki", value: "895"},
  {label: "Vaala", value: "785"},
  {label: "Vaasa", value: "905"},
  {label: "Valkeakoski", value: "908"},
  {label: "Vantaa", value: "092"},
  {label: "Varkaus", value: "915"},
  {label: "Vehmaa", value: "918"},
  {label: "Vesanto", value: "921"},
  {label: "Vesilahti", value: "922"},
  {label: "Veteli", value: "924"},
  {label: "Vieremä", value: "925"},
  {label: "Vihti", value: "927"},
  {label: "Viitasaari", value: "931"},
  {label: "Vimpeli", value: "934"},
  {label: "Virolahti", value: "935"},
  {label: "Virrat", value: "936"},
  {label: "Vårdö", value: "941"},
  {label: "Vöyri", value: "946"},
  {label: "Ylitornio", value: "976"},
  {label: "Ylivieska", value: "977"},
  {label: "Ylöjärvi", value: "980"},
  {label: "Ypäjä", value: "981"},
  {label: "Ähtäri", value: "989"},
  {label: "Äänekoski", value: "992"},
]